<template>
  <div class="second-tag-wrap">
    <div class="second-tag-filter">
      <el-select
        clearable
        @change="successCallBack"
        style="margin-right: 16px"
        v-model="formSearch.firstTagIds"
        filterable
        multiple
        collapse-tags
        class="filter-item all-select"
        placeholder="请选择一级标签"
        popper-class="BI-select BI-select-product"
      >
        <el-option v-for="item in tagOptions" :key="item.id" :label="item.name" :value="item.id"></el-option>
      </el-select>
      <el-select
        clearable
        @change="successCallBack"
        style="margin-right: 16px"
        v-model="formSearch.secondTagIds"
        filterable
        multiple
        collapse-tags
        class="filter-item all-select"
        placeholder="请选择二级标签"
        popper-class="BI-select BI-select-product"
      >
        <el-option v-for="item in secondTagOptions" :key="item.id" :label="item.name" :value="item.id"></el-option>
      </el-select>
      <el-select
        clearable
        @change="successCallBack"
        v-model="formSearch.operators"
        filterable
        multiple
        collapse-tags
        class="filter-item all-select"
        placeholder="请选择编辑人"
        popper-class="BI-select BI-select-product"
      >
        <el-option v-for="item in operatorsOptions" :key="item" :label="item" :value="item"></el-option>
      </el-select>
      <el-button @click="addTag">新建标签</el-button>
    </div>

    <div class="table">
      <el-table id="rebateSetTable" v-loading="loading" :data="tableData" style="width: 100%" height="100%">
        <el-table-column v-for="item of secondColumns" :label="item.label" :key="item.prop" :prop="item.prop" :width="item.width">
          <template slot-scope="scope">
            <div v-if="item.prop === 'operate'">
              <el-button type="text" @click="editTag(scope.row)">编辑</el-button>
              <el-button type="text" @click="deleteTag(scope.row)">删除</el-button>
            </div>
            <span v-else> {{ scope.row[item.prop] }}</span>
          </template>
        </el-table-column>
      </el-table>
      <self-pagination
        :total="pageData.total"
        :pageSize="pageData.size"
        :currentPage="pageData.page"
        ref="tabelPagination"
        @getCurrentPage="changePage"
        @handleSizeChange="changePageSize"
      ></self-pagination>
    </div>
    <add-tag-modal ref="addModal" @successCallBack="successCallBack" :tagOptions="tagOptions"></add-tag-modal>
  </div>
</template>

<script>
import { secondColumns } from "../config";
import AddTagModal from "./AddTagModal.vue";
import { getTagList, delTag, getSelectTagList } from "@/api/property.js";
export default {
  components: {
    AddTagModal,
  },
  props: {
    tagOptions: Array,
    operatorsOptions: Array,
  },

  data() {
    return {
      formSearch: {
        firstTagIds: [],
        secondTagIds: [],
        operators: [],
      },
      secondTagOptions: [],
      secondColumns,
      tableData: [],
      loading: false,
      pageData: {
        total: 0,
        size: 10,
        page: 1,
      },
      fileList: [], //上传的文件列表
    };
  },

  computed: {},

  watch: {
    "formSearch.firstTagIds": {
      handler(val, oldval) {
        // 判断是否新增选择
        if (val?.length < oldval?.length || oldval?.length === 0) {
          this.formSearch.secondTagIds = [];
        }
        this.getSecondOptions();
      },
      deep: true,
      immediate: true,
    },
  },

  mounted() {
    this.getList();
  },

  methods: {
    changePage(page) {
      this.pageData.page = page;
      this.getList();
    },
    changePageSize(size) {
      this.pageData.page = 1;
      this.pageData.size = size;
      this.getList();
    },
    getSecondOptions() {
      getSelectTagList({ dataLevel: 2, firstTagIds: this.formSearch.firstTagIds?.join(",") }).then((res) => {
        this.secondTagOptions = res.data;
      });
    },
    getList() {
      getTagList({
        pageSize: this.pageData.size,
        page: this.pageData.page,
        dataLevel: 2,
        operators: this.formSearch.operators.join(","),
        firstTagIds: this.formSearch.firstTagIds.join(","),
        secondTagIds: this.formSearch.secondTagIds.join(","),
      }).then((res) => {
        this.tableData = res.data.list;
        this.pageData.total = res.data.total;
      });
    },
    addTag() {
      this.$refs.addModal.openModal("second", "add");
    },
    editTag(data) {
      this.$refs.addModal.openModal("second", "edit", data);
    },
    deleteTag(record) {
      this.$confirm("确定删除该标签?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          delTag({ id: record.id }).then((res) => {
            if (res.code == "0000") {
              this.$message.success("删除成功");
              this.successCallBack();
            }
          });
        })
        .catch(() => {});
    },
    successCallBack() {
      this.pageData.page = 1;
      this.getList();
      this.getSecondOptions();
    },
  },
};
</script>

<style lang="less" scoped>
.second-tag-wrap {
  height: 100%;
  .second-tag-filter {
    display: flex;
    .filter-item {
      margin-right: 16px;
      /deep/ .el-input__inner {
        height: 32px !important;
      }
    }
  }
  .table {
    height: calc(100% - 135px);
    margin-top: 20px;
  }
}
</style>
